import { createOpenAICompatible } from "@ai-sdk/openai-compatible";
import { getAccessToken } from "@src/auth/auth-utils";
import config from "@src/config";

/**
 * OpenAI-compatible Illumi LLM gateway provider (chat + image models).
 * Shared by agent chat turns and in-chat image generation.
 */
export async function createIllumiProvider() {
	const token = await getAccessToken();
	if (!token) {
		throw new Error("You must be signed in to use agent chat");
	}

	return createOpenAICompatible({
		name: "illumi",
		apiKey: token,
		baseURL: `${config.llmBaseUrl.replace(/\/$/, "")}/v1`,
		includeUsage: true,
	});
}
